import axios from "axios";
import qs from "qs";
import { apiResponseHandler } from "./apiResponseHandler";
import { showAlert } from "./tools";

axios.defaults.withCredentials = true;

axios.headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
};

// send post request to server and manage message
export const postRequest = async (payload) => {  
  let rawResponse = await axios({
    method: "POST",
    url: payload.url.toLowerCase(),
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
    data: payload.data ? qs.stringify(payload.data) : "",
  }).catch((error) => {      
    return error.response;
  });  

  if (apiResponseHandler(rawResponse)?.messages?.length)
    showAlert(apiResponseHandler(rawResponse).messages);

  return apiResponseHandler(rawResponse);
};

// send get request to server and manage message
export const getRequest = async (payload) => {
  let rawResponse = await axios.get(payload.url.toLowerCase(), {
    headers: {
      "X-Requested-With": " XMLHttpRequest",
    },
    params: payload.params ? payload.params : {},
  });

  if (apiResponseHandler(rawResponse)?.messages?.length)
    showAlert(apiResponseHandler(rawResponse).messages);

  return apiResponseHandler(rawResponse);
};
